/* BBG (buyukbeden.com) — ürün sayfası eklentileri
   1) WhatsApp ile sipariş butonu: seçili varyant + adet ile mesajı günceller
   2) Toptan sipariş popup'ı: varyant/SKU alanlarını günceller, adet kontrolü, gönderim sonrası popup'ı yeniden açar
   3) Bedenimi Bul asistanı: kural tabanlı beden tahmini + ürün bedenleriyle eşleştirme
   Klasik script (module değil), theme.liquid'den defer ile yüklenir. */
(function () {
  if (window.__bbgPdpLoaded) return;
  window.__bbgPdpLoaded = true;

  /* ------------------------------------------------------------------ */
  /* Ortak: seçili varyant takibi                                        */
  /* ------------------------------------------------------------------ */
  var currentVariant = null;

  function readVariantFromUrl() {
    try {
      var id = new URL(window.location.href).searchParams.get('variant');
      return id ? { id: id } : null;
    } catch (e) { return null; }
  }

  function variantTitleFromDom(root) {
    /* Varyant seçicideki seçili değerleri "Renk / Beden" gibi birleştir.
       Sayfada birden fazla seçici olabilir (yapışkan sepet çubuğu vb.) — her option adı bir kez alınır. */
    var scope = root || document;
    var parts = [], seen = {};
    scope.querySelectorAll('.variant-option').forEach(function (opt) {
      var lbl = opt.querySelector('.variant-option__label-text');
      var key = lbl ? lbl.textContent.trim().toLocaleLowerCase('tr') : ('idx' + parts.length);
      if (seen[key]) return;
      var checked = opt.querySelector('input[type="radio"]:checked');
      var sel = opt.querySelector('select');
      var v = checked ? checked.value : (sel ? sel.value : null);
      if (v) { parts.push(v); seen[key] = true; }
    });
    return parts.join(' / ');
  }

  function getQty(root) {
    var scope = root || document;
    var input = scope.querySelector('quantity-selector-component input[name="quantity"], input[name="quantity"]');
    var q = input ? parseInt(input.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  document.addEventListener('variant:update', function (e) {
    var v = e && e.detail && e.detail.resource;
    if (v) currentVariant = v;
    scheduleRefresh();
  });

  /* ------------------------------------------------------------------ */
  /* 1) WhatsApp                                                         */
  /* ------------------------------------------------------------------ */
  function buildWhatsappHref(a) {
    var phone = a.getAttribute('data-phone') || '';
    var tpl = a.getAttribute('data-template') || '';
    var vt = (currentVariant && currentVariant.title && currentVariant.title !== 'Default Title')
      ? currentVariant.title
      : (variantTitleFromDom() || a.getAttribute('data-variant-title') || '');
    var url = a.getAttribute('data-product-url') || location.href.split('#')[0];
    if (currentVariant && currentVariant.id) {
      try {
        var u = new URL(url, location.origin);
        u.searchParams.set('variant', currentVariant.id);
        url = u.toString();
      } catch (e) { /* sessiz */ }
    }
    var price = a.getAttribute('data-price') || '';
    var msg = tpl
      .replace(/\[product\]/g, a.getAttribute('data-product-title') || document.title)
      .replace(/\[variant\]/g, vt)
      .replace(/\[qty\]/g, String(getQty()))
      .replace(/\[url\]/g, url)
      .replace(/\[price\]/g, price);
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(msg);
  }

  function refreshWhatsapp() {
    document.querySelectorAll('[data-bbg-whatsapp]').forEach(function (a) {
      a.setAttribute('href', buildWhatsappHref(a));
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bbg-whatsapp]');
    if (a) a.setAttribute('href', buildWhatsappHref(a));
  }, true);

  /* ------------------------------------------------------------------ */
  /* 2) Toptan sipariş                                                   */
  /* ------------------------------------------------------------------ */
  function refreshWholesale() {
    document.querySelectorAll('[data-bbg-wholesale]').forEach(function (comp) {
      var vt = (currentVariant && currentVariant.title && currentVariant.title !== 'Default Title')
        ? currentVariant.title : variantTitleFromDom();
      var sku = currentVariant && currentVariant.sku ? currentVariant.sku : null;
      var vField = comp.querySelector('[data-bbg-field="variant"]');
      var sField = comp.querySelector('[data-bbg-field="sku"]');
      var uField = comp.querySelector('[data-bbg-field="url"]');
      var vLabel = comp.querySelector('[data-bbg-variant-label]');
      var sLabel = comp.querySelector('[data-bbg-variant-sku]');
      if (vt) {
        if (vField) vField.value = vt;
        if (vLabel) vLabel.textContent = vt;
      }
      if (sku !== null) {
        if (sField) sField.value = sku;
        if (sLabel) sLabel.textContent = sku;
      }
      if (uField && currentVariant && currentVariant.id) {
        try {
          var u = new URL(uField.value || location.href, location.origin);
          u.searchParams.set('variant', currentVariant.id);
          uField.value = u.toString();
        } catch (e) { /* sessiz */ }
      }
    });
  }

  function initWholesale(comp) {
    if (comp.__bbgInit) return;
    comp.__bbgInit = true;
    var qty = comp.querySelector('[data-bbg-qty]');
    var minNote = comp.querySelector('[data-bbg-min-note]');
    var minWholesale = qty ? parseInt(qty.getAttribute('data-min-wholesale') || '1', 10) : 1;
    comp.querySelectorAll('[data-bbg-order-type]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!qty) return;
        var wholesale = r.value.toLowerCase().indexOf('toptan') > -1;
        if (wholesale) {
          qty.min = String(minWholesale);
          if (parseInt(qty.value, 10) < minWholesale) qty.value = String(minWholesale);
          if (minNote) minNote.hidden = false;
        } else {
          qty.min = '1';
          if (minNote) minNote.hidden = true;
        }
      });
    });
    var form = comp.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (ev) {
        var wholesaleChecked = comp.querySelector('[data-bbg-order-type]:checked');
        var isWholesale = wholesaleChecked && wholesaleChecked.value.toLowerCase().indexOf('toptan') > -1;
        if (qty && isWholesale && parseInt(qty.value, 10) < minWholesale) {
          ev.preventDefault();
          var minTpl = qty.getAttribute('data-i18n-min') || 'Toptan siparişte minimum __min__ adet.';
          qty.setCustomValidity(minTpl.split('__min__').join(String(minWholesale)));
          qty.reportValidity();
          setTimeout(function () { qty.setCustomValidity(''); }, 2500);
          return;
        }
        var btn = form.querySelector('[type="submit"]');
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('btn--loading'); }
      });
    }
    /* Gönderim sonrası (başarı/hata) popup'ı otomatik aç */
    if (comp.querySelector('[data-bbg-open-dialog]')) {
      var tryOpen = function (n) {
        if (typeof comp.showDialog === 'function') { comp.showDialog(); return; }
        var d = comp.querySelector('dialog');
        if (d && typeof d.showModal === 'function' && !d.open) { try { d.showModal(); return; } catch (e) { /* tekrar dene */ } }
        if (n < 20) setTimeout(function () { tryOpen(n + 1); }, 150);
      };
      tryOpen(0);
    }
  }

  /* ------------------------------------------------------------------ */
  /* 3) Bedenimi Bul                                                     */
  /* ------------------------------------------------------------------ */
  /* Varsayılan büyük beden tabloları (cm). tr: Türk beden karşılığı. */
  var CHART_WOMEN = [
    { size: 'L',   tr: '40-42', bust: [92, 100],  waist: [76, 84],   hips: [100, 108] },
    { size: 'XL',  tr: '44-46', bust: [100, 108], waist: [84, 92],   hips: [108, 116] },
    { size: '2XL', tr: '48-50', bust: [108, 116], waist: [92, 100],  hips: [116, 124] },
    { size: '3XL', tr: '52-54', bust: [116, 124], waist: [100, 108], hips: [124, 132] },
    { size: '4XL', tr: '56-58', bust: [124, 132], waist: [108, 116], hips: [132, 140] },
    { size: '5XL', tr: '60-62', bust: [132, 140], waist: [116, 124], hips: [140, 148] },
    { size: '6XL', tr: '64-66', bust: [140, 148], waist: [124, 132], hips: [148, 156] },
    { size: '7XL', tr: '68-70', bust: [148, 156], waist: [132, 140], hips: [156, 164] },
    { size: '8XL', tr: '72-74', bust: [156, 164], waist: [140, 148], hips: [164, 172] }
  ];
  var CHART_MEN = [
    { size: 'L',   tr: '52',    bust: [100, 106], waist: [88, 94],   hips: [102, 108] },
    { size: 'XL',  tr: '54-56', bust: [106, 114], waist: [94, 102],  hips: [108, 114] },
    { size: '2XL', tr: '58-60', bust: [114, 122], waist: [102, 110], hips: [114, 120] },
    { size: '3XL', tr: '62-64', bust: [122, 130], waist: [110, 118], hips: [120, 126] },
    { size: '4XL', tr: '66-68', bust: [130, 138], waist: [118, 126], hips: [126, 132] },
    { size: '5XL', tr: '70-72', bust: [138, 146], waist: [126, 134], hips: [132, 138] },
    { size: '6XL', tr: '74-76', bust: [146, 154], waist: [134, 142], hips: [138, 144] },
    { size: '7XL', tr: '78-80', bust: [154, 162], waist: [142, 150], hips: [144, 150] },
    { size: '8XL', tr: '82-84', bust: [162, 170], waist: [150, 158], hips: [150, 156] }
  ];

  var STORAGE_KEY = 'bbg:size-finder';

  function pickChart(comp) {
    var raw = comp.getAttribute('data-chart');
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length && parsed[0].size) return parsed;
      } catch (e) { console.warn('[BBG size-finder] size_chart_json okunamadı:', e); }
    }
    var g = comp.getAttribute('data-gender') || 'auto';
    if (g === 'men') return CHART_MEN;
    if (g === 'women') return CHART_WOMEN;
    var hint = ((comp.getAttribute('data-product-type') || '') + ' ' + document.title + ' ' + (comp.closest('product-information, .product-information, main') || document.body).textContent.slice(0, 400)).toLocaleLowerCase('tr');
    if (/\berkek\b|\bman\b|\bmen\b|\bbay\b/.test(hint) && !/kadın|kadin|women|bayan/.test(hint)) return CHART_MEN;
    return CHART_WOMEN;
  }

  /* Boy/kilo -> tahmini çevre ölçüleri (cm). Antropometrik regresyon yaklaşımı;
     göğüs/bel/kalça girilmişse gerçek ölçüler öncelikli. */
  function estimateMeasures(h, w, isMen) {
    var bmi = w / Math.pow(h / 100, 2);
    var bust, waist, hips;
    if (isMen) {
      bust = 42.5 + bmi * 2.3;
      waist = 32.5 + bmi * 2.3;
      hips = 64 + bmi * 1.6;
    } else {
      bust = 44 + bmi * 2.0;
      waist = 20.5 + bmi * 2.25;
      hips = 52 + bmi * 2.0;
    }
    /* uzun boylularda aynı BMI daha geniş çevre yapmaz; hafif düzeltme */
    var hAdj = (h - 165) * 0.08;
    return { bust: bust + hAdj, waist: waist + hAdj, hips: hips + hAdj, bmi: bmi };
  }

  function mid(r) { return (r[0] + r[1]) / 2; }

  function scoreRow(row, m, weights) {
    var s = 0, tw = 0;
    ['bust', 'waist', 'hips'].forEach(function (k) {
      if (!row[k] || m[k] == null) return;
      var d = Math.abs(m[k] - mid(row[k])) / Math.max(1, (row[k][1] - row[k][0]));
      s += d * weights[k]; tw += weights[k];
    });
    return tw ? s / tw : 999;
  }

  function recommend(chart, input, isMen) {
    var est = estimateMeasures(input.height, input.weight, isMen);
    var m = {
      bust: input.bust || est.bust,
      waist: input.waist || est.waist,
      hips: input.hips || est.hips
    };
    /* gerçek ölçü girilen alanlar daha ağır basar */
    var weights = {
      bust: input.bust ? 1.6 : 1,
      waist: input.waist ? 1.4 : 1,
      hips: input.hips ? 1.4 : 1
    };
    var scored = chart.map(function (row, i) { return { i: i, row: row, s: scoreRow(row, m, weights) }; });
    scored.sort(function (a, b) { return a.s - b.s; });
    var best = scored[0], idx = best.i;
    /* Kalıp tercihi: dar -> aynı; rahat -> ölçü üst sınıra yakınsa bir üst */
    if (input.fit === 'loose' && idx < chart.length - 1) {
      idx = Math.min(chart.length - 1, idx + 1);
    } else if (input.fit === 'slim' && idx > 0 && best.s < 0.25) {
      /* çok net oturuyorsa dar tercih için bir alta inme */
      idx = Math.max(0, idx - (best.s < 0.12 ? 1 : 0));
    }
    var confidence = best.s < 0.35 ? 'high' : (best.s < 0.75 ? 'medium' : 'low');
    var hasRealMeasures = !!(input.bust || input.waist || input.hips);
    return { index: idx, row: chart[idx], alt: chart[Math.min(chart.length - 1, idx + 1)], confidence: confidence, estimated: !hasRealMeasures, measures: m };
  }

  /* Ürün beden değerlerini "sıra" olarak yorumla: 1XL/XL=1, 2XL=2 ... ; sayısal 42/44 -> TR */
  function parseSizeToken(v) {
    var t = String(v).trim().toLocaleUpperCase('tr').replace(/İ/g, 'I').replace(/\s+/g, '');
    var m;
    if ((m = t.match(/^([0-9]{1,2})XL$/))) return { kind: 'xl', n: parseInt(m[1], 10) };
    if (t === 'XL') return { kind: 'xl', n: 1 };
    if ((m = t.match(/^X{2,}L$/))) return { kind: 'xl', n: t.length - 1 };
    if (t === 'L') return { kind: 'xl', n: 0 };
    if (t === 'M') return { kind: 'xl', n: -1 };
    if (t === 'S') return { kind: 'xl', n: -2 };
    if ((m = t.match(/^([0-9]{2,3})(?:[-\/–]([0-9]{2,3}))?/))) {
      var a = parseInt(m[1], 10), b = m[2] ? parseInt(m[2], 10) : a;
      return { kind: 'tr', n: (a + b) / 2, lo: a, hi: b };
    }
    return null;
  }

  function rowXlIndex(row) {
    var p = parseSizeToken(row.size);
    return p && p.kind === 'xl' ? p.n : null;
  }
  function rowTrMid(row) {
    if (!row.tr) return null;
    var p = parseSizeToken(String(row.tr));
    return p && p.kind === 'tr' ? p.n : null;
  }

  function matchProductSize(values, rec, chart) {
    if (!values || !values.length) return null;
    var targetXl = rowXlIndex(rec.row);
    var targetTr = rowTrMid(rec.row);
    var best = null, bestD = Infinity;
    values.forEach(function (v) {
      var p = parseSizeToken(v);
      if (!p) return;
      var d;
      if (p.kind === 'xl' && targetXl != null) d = Math.abs(p.n - targetXl);
      else if (p.kind === 'tr' && targetTr != null) d = Math.abs(p.n - targetTr) / 2; /* 2 beden = 1 XL adımı */
      else return;
      if (d < bestD) { bestD = d; best = v; }
    });
    return best ? { value: best, exact: bestD < 0.75 } : null;
  }

  function findSizeInput(value, optionIndex) {
    /* Buton stili */
    var groups = Array.prototype.slice.call(document.querySelectorAll('.variant-option'));
    var group = null;
    groups.forEach(function (g) {
      var lbl = g.querySelector('.variant-option__label-text');
      var t = lbl ? lbl.textContent.toLocaleLowerCase('tr') : '';
      if (!group && (t.indexOf('beden') > -1 || t.indexOf('size') > -1 || t.indexOf('numara') > -1)) group = g;
    });
    if (!group && optionIndex >= 0 && groups[optionIndex]) group = groups[optionIndex];
    if (!group) return null;
    var norm = function (s) { return String(s).trim().toLocaleUpperCase('tr').replace(/\s+/g, ''); };
    var input = null;
    group.querySelectorAll('input[type="radio"]').forEach(function (i) { if (!input && norm(i.value) === norm(value)) input = i; });
    if (input) return { type: 'radio', el: input };
    var sel = group.querySelector('select');
    if (sel) {
      var opt = Array.prototype.find.call(sel.options, function (o) { return norm(o.value) === norm(value); });
      if (opt) return { type: 'select', el: sel, value: opt.value };
    }
    return null;
  }

  function initSizeFinder(comp) {
    if (comp.__bbgInit) return;
    comp.__bbgInit = true;
    var form = comp.querySelector('[data-bbg-size-form]');
    var result = comp.querySelector('[data-bbg-size-result]');
    var errEl = comp.querySelector('[data-bbg-size-error]');
    var primary = comp.querySelector('[data-bbg-size-primary]');
    var secondary = comp.querySelector('[data-bbg-size-secondary]');
    var note = comp.querySelector('[data-bbg-size-note]');
    var applyBtn = comp.querySelector('[data-bbg-size-apply]');
    var resetBtn = comp.querySelector('[data-bbg-size-reset]');
    if (!form || !result) return;

    var sizeValues = (comp.getAttribute('data-size-values') || '').split('|').filter(Boolean);
    var optionIndex = parseInt(comp.getAttribute('data-size-option-index') || '-1', 10);
    var chart = pickChart(comp);
    var isMen = chart === CHART_MEN;
    /* i18n: sunucunun bastığı data-i18n-* kalıpları (yoksa Türkçe geri dönüş) */
    var sT = function (key, fallback) { var v = comp.getAttribute('data-i18n-' + key); return v != null && v !== '' ? v : fallback; };
    var sFill = function (s, map) { s = String(s); for (var k in map) s = s.split('__' + k + '__').join(String(map[k])); return s; };
    var applyDefault = applyBtn ? applyBtn.textContent : 'Bu Bedeni Seç';

    /* önceki girdileri hatırla */
    try {
      var saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved) Object.keys(saved).forEach(function (k) { var f = form.elements[k]; if (f && saved[k]) f.value = saved[k]; });
    } catch (e) { /* sessiz */ }

    var lastMatch = null;

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      errEl.hidden = true;
      var input = {
        height: parseFloat(form.elements.height.value),
        weight: parseFloat(form.elements.weight.value),
        bust: parseFloat(form.elements.bust.value) || 0,
        waist: parseFloat(form.elements.waist.value) || 0,
        hips: parseFloat(form.elements.hips.value) || 0,
        fit: form.elements.fit.value || 'regular'
      };
      if (!(input.height >= 130 && input.height <= 220) || !(input.weight >= 40 && input.weight <= 250)) {
        errEl.textContent = sT('error', 'Lütfen boy (130-220 cm) ve kilo (40-250 kg) bilgilerinizi kontrol edin.');
        errEl.hidden = false;
        return;
      }
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(input)); } catch (e) { /* sessiz */ }

      var rec = recommend(chart, input, isMen);
      var match = matchProductSize(sizeValues, rec, chart);
      lastMatch = match;

      var label = rec.row.size + (rec.row.tr ? ' (' + rec.row.tr + ')' : '');
      if (match) {
        primary.textContent = match.value;
        secondary.textContent = match.exact ? sFill(sT('exact', 'Tablo karşılığı: __label__'), { label: label }) : sFill(sT('nearest', 'Tabloya göre __label__ — bu üründe en yakın seçenek: __value__'), { label: label, value: match.value });
      } else {
        primary.textContent = rec.row.size;
        secondary.textContent = rec.row.tr ? sFill(sT('tr-size', 'Türk bedeni: __tr__'), { tr: rec.row.tr }) : '';
      }

      var msgs = [];
      if (rec.estimated) msgs.push(sT('estimated', 'Göğüs/bel/kalça ölçünüzü de girerseniz öneri daha isabetli olur.'));
      if (rec.confidence === 'low') msgs.push(sFill(sT('low', 'Ölçüleriniz iki beden arasında; rahat kalıp için __size__ bedenini de değerlendirin.'), { size: rec.alt.size }));
      else if (rec.confidence === 'medium') msgs.push(sFill(sT('alt', 'Alternatif: __size__'), { size: rec.alt.size }) + (rec.alt.tr ? ' (' + rec.alt.tr + ')' : ''));
      note.textContent = msgs.join(' ');

      var target = match ? findSizeInput(match.value, optionIndex) : null;
      if (applyBtn) {
        applyBtn.hidden = !target;
        applyBtn.textContent = target ? sFill(sT('apply', 'Bu Bedeni Seç: __size__'), { size: match.value }) : applyDefault;
      }
      form.hidden = true;
      result.hidden = false;
      comp.dispatchEvent(new CustomEvent('bbg:size-recommended', { bubbles: true, detail: { recommendation: rec, match: match } }));
    });

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        if (!lastMatch) return;
        var target = findSizeInput(lastMatch.value, optionIndex);
        if (!target) return;
        if (target.type === 'radio') {
          target.el.click();
          target.el.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          target.el.value = target.value;
          target.el.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (typeof comp.closeDialog === 'function') comp.closeDialog();
        else { var d = comp.querySelector('dialog'); if (d && d.open) d.close(); }
      });
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        result.hidden = true;
        form.hidden = false;
        var first = form.querySelector('input');
        if (first) first.focus();
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Başlatma                                                            */
  /* ------------------------------------------------------------------ */
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshWhatsapp();
      refreshWholesale();
    }, 60);
  }

  function initAll() {
    document.querySelectorAll('[data-bbg-wholesale]').forEach(initWholesale);
    document.querySelectorAll('[data-bbg-size-finder]').forEach(initSizeFinder);
    if (!currentVariant) currentVariant = readVariantFromUrl();
    scheduleRefresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Varyant değişiminde section morph edilirse yeni bloklar gelir; adet değişimini de yakala */
  var mo = new MutationObserver(function () { initAllDebounced(); });
  var initTimer = null;
  function initAllDebounced() { clearTimeout(initTimer); initTimer = setTimeout(initAll, 120); }
  mo.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', function (e) {
    if (e.target && (e.target.name === 'quantity' || e.target.closest('.variant-option'))) scheduleRefresh();
  });
  document.addEventListener('quantity-selector:update', scheduleRefresh);
})();
